import { render } from "./hire.vue?vue&type=template&id=a270c902&scoped=true"
import script from "./hire.vue?vue&type=script&lang=js"
export * from "./hire.vue?vue&type=script&lang=js"

import "./hire.vue?vue&type=style&index=0&id=a270c902&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a270c902"]])

export default __exports__